__turbopack_context__.v({
  "text": "ToBeAnnouncedLocation-module-scss-module__rmHNuG__text",
  "toBeAnnouncedLocation": "ToBeAnnouncedLocation-module-scss-module__rmHNuG__toBeAnnouncedLocation",
});
